<template>
  <VTooltip
    placement="bottom"
    :triggers="['click', 'hover']"
    popper-class="custom-tooltip"
  >
    <slot />
    <template #popper>
      <slot name="content" />
    </template>
  </VTooltip>
</template>

<style>
.custom-tooltip {
  .v-popper__inner {
    @apply py-3 px-6 bg-ctr max-w-96 mx-2;
  }
  .v-popper__arrow-outer {
    @apply border-ctr;
  }
}
</style>
